import * as documentPackageActions from "@rentiohq/shared-frontend/dist/reduxV2/documentPackage/documentPackage.actions";
import * as documentPackageSelectors from "@rentiohq/shared-frontend/dist/reduxV2/documentPackage/documentPackage.selectors";
import {
  IDocumentPackageCreate,
  IDocumentPackageCreateSigner,
} from "@rentiohq/shared-frontend/dist/reduxV2/documentPackage/documentPackage.types";
import * as templateDocumentActions from "@rentiohq/shared-frontend/dist/reduxV2/templateDocuments/templateDocument.actions";
import * as templateDocumentSelectors from "@rentiohq/shared-frontend/dist/reduxV2/templateDocuments/templateDocument.selectors";
import { getSignerForAccountId } from "@rentiohq/shared-frontend/dist/utils/documentPackage.utils";
import { IRootStore } from "redux/reducers";
import { getAutoRegistrationForSubmit } from "./schema.createDocumentPackage.7.utils";
import { EField, IExtraData } from "./schema.createDocumentPackage.types";
import {
  getRelatedContract,
  getRelatedProperty,
  getSigningTypes,
} from "./schema.createDocumentPackage.utils";

export const isPerformingSubmitActionSelector =
  (extraData: IExtraData) => (state: IRootStore) => {
    const { sendToTenant, templateDocument } = extraData;

    if (sendToTenant && templateDocument) {
      return templateDocumentSelectors.isUpdating(state, templateDocument.id);
    }

    return !!documentPackageSelectors.isCreatingDocumentPackage(state);
  };

export const performingSubmitActionResultSelector =
  (extraData: IExtraData) => (state: IRootStore) => {
    const { sendToTenant, templateDocument } = extraData;

    if (sendToTenant && templateDocument) {
      return templateDocumentSelectors.getDetail(state, templateDocument.id);
    }
    return documentPackageSelectors.getCreatedDetail(state);
  };

export const performingSubmitActionErrorSelector =
  (extraData: IExtraData) => (state: IRootStore) => {
    const { sendToTenant, templateDocument } = extraData;

    if (sendToTenant && templateDocument) {
      return templateDocumentSelectors.updateError(state, templateDocument.id);
    }
    return documentPackageSelectors.createDocumentPackageError(state);
  };

export const submitActionCreator =
  (extraData: IExtraData) => (formData: any) => {
    const relatedContract = getRelatedContract(extraData, formData);
    const relatedProperty = getRelatedProperty(extraData, formData);

    const allowedSigningTypes = getSigningTypes(
      formData[EField.SigningTypes] || [],
    );

    const { sendToTenant, templateDocument } = extraData;

    if (sendToTenant && templateDocument) {
      return templateDocumentActions.updateStart.getAction({
        id: templateDocument.id,
        data: {
          allowedSigningTypes,
        },
      });
    } else {
      const signers = [...(formData[EField.Signers] || [])];

      const signAsBroker = formData[EField.SignAsBroker] || [];
      if (signAsBroker.length > 0) {
        signers.push(+signAsBroker[0]);
      }

      const signerObjects = signers.map(
        (accountId: number): IDocumentPackageCreateSigner =>
          getSignerForAccountId({
            accountId,
            allowedSigningTypes,
            contract: relatedContract,
            property: relatedProperty,
          }),
      );

      // Both are only set when the broker opted in on the auto-registration
      // step: `rentRegistration` is one the saga creates and then links onto
      // the package, `rentRegistrationId` the lease's existing registration
      // that an inspection report is attached to.
      const { rentRegistration, rentRegistrationId } =
        getAutoRegistrationForSubmit({ formData, extraData });

      const documentPackage: IDocumentPackageCreate = {
        type: formData[EField.DocumentPackageType],

        propertyId: relatedProperty?.id,
        contractId: relatedContract?.id,

        documents: formData[EField.Documents] || [],

        name: formData[EField.Name],
        signers: signerObjects,

        ...(rentRegistrationId != null ? { rentRegistrationId } : {}),
      };

      return documentPackageActions.createDocumentPackageStart.getAction({
        data: documentPackage,
        rentRegistration,
      });
    }
  };
